import metadata from "./block.json";
import Edit from "./button-edit";
import Save from "./button-save";
import IconCard from "./button-icon";
import "./style.scss";

const DEOHSButton = {
  ...metadata,
  icon: IconCard,
  edit: Edit,
  save: Save,
};

export default DEOHSButton;


/**
 * To do list for Button
 *
 * 1. Validate the input
 * 2. Load a form below the button
 * 3. Are styles such as outline buttons and buttons other than purple needed?
 *
 */